module.exports = __webpack_public_path__ + "static/img/lbbg1.e0397af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg1.png
// module id = 0UKG
// module chunks = 0